import { z } from 'zod';

export const partnerIntegrationCredentialsSchema = z.object({
  displayName: z.string().nullable(),
  propertyName: z.string().nullable(),
  protected: z.boolean().nullable(),
  description: z.string().nullable(),
});

export type PartnerIntegrationCredentials = z.infer<
  typeof partnerIntegrationCredentialsSchema
>;
